import CartCrossSell from './CartCrossSell';
import CartEmpty from './CartEmpty';
import CartItem from './CartItem';
import CartTotals from './CartTotals';
import FocusTrap from 'focus-trap-react';

import cn from 'classnames';
import { createPortal } from 'preact/compat';
import { getTranslation } from '../../helpers';
import { h } from 'preact';
import { useCartContext } from '../context/CartContext';

const MiniCartDrawerEl = document.getElementById('preact-mini-cart-drawer');

const MiniCart = () => {
  const { cart, isMiniCartOpen, toggleMiniCart } = useCartContext();

  const handleSignUp = () => {
    toggleMiniCart(false);
    document.getElementById('newsletter-signup').scrollIntoView({
      behavior: 'smooth',
    });
  };

  return createPortal(
    <FocusTrap active={isMiniCartOpen}>
      <div
        class={cn(
          'fixed inset-0',
          isMiniCartOpen
            ? 'opacity-1 visible'
            : `invisible opacity-0 delay-300`,
        )}
      >
        <div
          onClick={() => toggleMiniCart(false)}
          class={cn(
            `absolute inset-0 bg-grey-1 transition-opacity duration-300`,
            isMiniCartOpen ? 'opacity-50' : 'opacity-0',
          )}
        />
        <div
          class={cn(
            `absolute bottom-0 right-0 top-0 z-50 flex w-11/12 flex-col bg-white transition-transform duration-300 sm:w-full sm:max-w-md md:max-w-2xl`,
            isMiniCartOpen ? 'translate-x-0' : 'translate-x-full',
          )}
        >
          <div class="flex items-center justify-between bg-taupe px-4 py-4 md:px-6">
            <h3 className="type-heading-3">Cart ({cart.item_count})</h3>
            <button
              onClick={() => toggleMiniCart(false)}
              className="flex size-8 items-center justify-center rounded-full border border-black"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="size-3"
                fill="none"
                viewBox="0 0 24 24"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M23.3139 0.899522C23.7044 1.29005 23.7044 1.92321 23.3139 2.31374L13.4144 12.2132L23.3139 22.1127C23.7044 22.5032 23.7044 23.1364 23.3139 23.5269C22.9233 23.9175 22.2902 23.9175 21.8997 23.5269L12.0002 13.6274L2.10066 23.5269C1.71014 23.9175 1.07697 23.9175 0.686448 23.5269C0.295923 23.1364 0.295924 22.5032 0.686448 22.1127L10.5859 12.2132L0.686448 2.31374C0.295924 1.92321 0.295923 1.29005 0.686448 0.899522C1.07697 0.508997 1.71014 0.508997 2.10066 0.899522L12.0002 10.799L21.8997 0.899522C22.2902 0.508997 22.9233 0.508997 23.3139 0.899522Z"
                  fill="currentColor"
                />
              </svg>
            </button>
          </div>

          <div
            class="flex flex-col-reverse gap-4 overflow-auto px-4 py-4 md:gap-6 md:px-8 md:py-6"
            data-cart-items
            data-scroll-lock-scrollable
          >
            <CartCrossSell />

            {cart.items && cart.items.length > 0 ? (
              cart.items.map(item => <CartItem item={item} key={item.key} />)
            ) : (
              <CartEmpty />
            )}
          </div>

          <div class="mt-auto">
            <div class="rte type-body-small bg-primary-1/50 px-4 py-6 text-center md:px-6">
              Join the Cloudrest Community and save an{' '}
              <strong>additional 20% off</strong> your first order.{' '}
              <button
                type="button"
                href="#newsletter-signup"
                onClick={handleSignUp}
              >
                Sign up
              </button>
            </div>
            <div class="bg-taupe px-4 py-6 md:px-6">
              {cart.total_price > 0 && <CartTotals cart={{ ...cart }} />}

              <div class="mt-4 flex items-center justify-between">
                <button
                  onClick={() => toggleMiniCart(false)}
                  class="type-body-small underline hover:no-underline"
                >
                  {getTranslation('mini_cart.keep_shopping')}
                </button>

                <form action={`${Shopify.routes.root}cart`} method="POST">
                  <button
                    type="submit"
                    name="checkout"
                    class="button button--primary"
                  >
                    {getTranslation('mini_cart.checkout')}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </FocusTrap>,
    MiniCartDrawerEl,
  );
};

export default MiniCart;
